export interface PriceInfo {
  current: string
  compareAt: string
  currency: string
  discount: string
}

const PRICE_TABLE: Record<string, PriceInfo> = {
  CL: {
    current: '15.990',
    compareAt: '43.999',
    currency: 'CLP',
    discount: '-64%',
  },
  AR: {
    current: '23.999',
    compareAt: '70.999',
    currency: 'ARS',
    discount: '-66%',
  },
  CO: {
    current: '63.999',
    compareAt: '189.999',
    currency: 'COP',
    discount: '-66%',
  },
  MX: {
    current: '299',
    compareAt: '899',
    currency: 'MXN',
    discount: '-67%',
  },
  UY: {
    current: '670',
    compareAt: '1.999',
    currency: 'UYU',
    discount: '-67%',
  },
  ES: {
    current: '14,99',
    compareAt: '42,99',
    currency: 'EUR',
    discount: '-65%',
  },
  US: {
    current: '16,99',
    compareAt: '49,99',
    currency: 'USD',
    discount: '-66%',
  },
}

const DEFAULT_PRICE: PriceInfo = {
  current: '16,99',
  compareAt: '49,99',
  currency: 'USD',
  discount: '-66%',
}

export function getPriceByCountry(countryCode: string): PriceInfo {
  return PRICE_TABLE[countryCode] ?? DEFAULT_PRICE
}

export { DEFAULT_PRICE }
